export default {
  state: {
    promo: {
      show: false,
      geofence: null,
      refreshID: null,
      list: []
    }
  },
  mutations: {
    setGeofencePromoShow (state, value) {
      state.promo.show = value
      state.promo.refreshID = null
    },
    setGeofencePromo (state, value) { state.promo.geofence = value },
    setGeofencePromoList (state, value) { state.promo.list = value },
    setGeofencePromoRefreshID (state, value) { state.promo.refreshID = value }
  }
}



// WEBPACK FOOTER //
// ./src/store/geofences/geofence-promo.js